// extracted by mini-css-extract-plugin
export var authorAvatarContainer = "S_cK";
export var authorInfoContainer = "S_cL";
export var authorInfoDetails = "S_cM";
export var authorInfoSection = "S_cN";
export var authorSocialLinks = "S_cQ";
export var authorTooltipContainer = "S_cR";
export var authorTooltipContent = "S_cJ";
export var authorTooltipLink = "S_cP";
export var authorTooltipZIndex = "S_cS";